/* eslint-disable max-len */
import {
    Button,
    Dialog, DialogContent, DialogContentText, DialogTitle, InputAdornment, TextField, Typography
} from '@material-ui/core'
import { makeStyles } from '@material-ui/core/styles'
import * as React from 'react'
import { fadeIn } from 'react-animations'
import { useHistory } from 'react-router-dom'
import styled, { keyframes } from 'styled-components'

import map from '../../assets/map.png'
import { buttonsStyles } from '../../styles/ButtonsStyles'

const useStyles = makeStyles(() => ({
    centerAdornment: {
        marginLeft: '80%' // or your relevant measure
    },
    centerText: {
        textAlign: 'end'
    },
    container: {
        display: 'flex',
        flexWrap: 'wrap',
        flexDirection: 'row',
        marginLeft: 20,
        paddingLeft: 15
    },

    cssLabel: {
        color: '#33949E'
    },

    cssOutlinedInput: {
        fontSize: '18px !important',
        textAlign: 'right',
        display: 'flex',
        justifyContent: 'flex-end !important',
        alignContent: 'flex-end !important',
        alignSelf: 'end !important',
        '&$cssFocused $notchedOutline': {
            borderColor: 'white !important',
            color: 'white !important',
            display: 'flex',
            justifyContent: 'flex-end !important',
            alignContent: 'flex-end !important',
            alignSelf: 'end !important'
        },
        '&::placeholder': {
            display: 'flex',
            justifyContent: 'flex-end !important',
            alignContent: 'flex-end !important',
            alignSelf: 'end !important'
        }
    },

    cssFocused: {
        color: 'white !important',
        textAlign: 'right',
        display: 'flex',
        justifyContent: 'flex-end !important',
        alignContent: 'flex-end !important',
        alignSelf: 'end !important'
    },

    notchedOutline: {
        borderWidth: '1px',
        color: 'white',
        borderColor: '#33949E !important',
        textAlign: 'right',
        display: 'flex',
        justifyContent: 'flex-end !important',
        alignContent: 'flex-end !important',
        alignSelf: 'end !important'
    },
}))

const bounceAnimation = keyframes`${fadeIn}`

const BouncyDiv = styled.div`
  animation: 5s ${bounceAnimation};
  
  margin-bottom: 15px;
`
interface Props {
    title: string
    open: boolean
    seconds: number
    videoUri: string
    materialUri?: any
    materialKey?: any
    materialImage?: string
    answersImage?: string
    description: string
    selected?: boolean
    onClose(): void
    onSelect?(seconds: number): void
}

export const PuzzleDetailsModal: React.FC<Props> = ({
    title, description,
    onClose, open, seconds, onSelect,
    selected, materialUri, materialKey, materialImage, videoUri, answersImage
}) => {
    const [minutes, setMinutes] = React.useState((seconds / 60).toString())
    const history = useHistory()

    const btnStyles = buttonsStyles()
    const classes = useStyles()

    const n = Number(minutes)
    const isGoodTime = !Number.isNaN(n) && n > 0

    return (
        <div style={{
            padding: 15
        }}>
            <Dialog
                style={{
                    padding: 15,
                    backdropFilter: 'blur(3px)',
                    backgroundColor: 'rgba(0,0,30,0.4)'
                }}
                open={open}
                keepMounted
                aria-describedby="alert-dialog-slide-description">
                <div style={{ display: 'flex', justifyContent: 'space-between', padding: 15 }}>

                    <DialogTitle style={{ color: 'white' }}>{title}</DialogTitle>
                    <Button
                        style={{
                            color: 'white', display: 'flex', justifyContent: 'end', padding: 15, fontSize: 20
                        }}
                        onClick={onClose}>
                        X
                    </Button>
                </div>
                <div style={{ display: 'flex', flexDirection: 'row' }}>
                    <form className={classes.container} noValidate autoComplete="off">
                        <TextField
                            multiline={false}
                            autoFocus
                            variant="outlined"
                            value={minutes}
                            error={!isGoodTime}
                            helperText={!isGoodTime && 'Ugyldigt antal minutter'}
                            margin="normal"
                            onChange={(c) => setMinutes(c.target.value)}
                            InputLabelProps={{
                                classes: {
                                    root: classes.cssLabel,
                                    focused: classes.cssFocused,

                                },
                            }}
                            InputProps={{
                                classes: {
                                    focused: classes.cssFocused,
                                    notchedOutline: classes.notchedOutline,

                                },
                                startAdornment: (
                                    <InputAdornment
                                        position="start"
                                        classes={{
                                            root: classes.cssOutlinedInput,
                                            positionStart: classes.centerAdornment
                                        }} />
                                )
                            }}/>
                        <Typography style={{
                            color: 'white', display: 'flex', alignItems: 'center', paddingTop: 12, paddingLeft: 10
                        }}>
                            minutter
                        </Typography>
                    </form>
                </div>

                <DialogContent>
                    <p style={{ paddingLeft: 15, fontWeight: 500, color: '#33949E', }}>Denne opgave omhandler</p>
                    <DialogContentText
                        style={{ color: 'white', textAlign: 'justify', padding: '0px 15px' }}
                        id="alert-dialog-slide-description">
                        {description}
                    </DialogContentText>

                    <div style={{ paddingLeft: 15, marginBottom: 15 }}>
                        <Typography style={{ fontWeight: 500, color: '#33949E' }}>
                            Opgavevideo
                        </Typography>
                        <a
                            style={{ color: 'white', textDecoration: 'none', cursor: 'pointer' }}
                            target="_blank"
                            href={videoUri}
                            rel="noreferrer">Se videoopgaven
                        </a>
                    </div>

                    {!!materialKey && !!materialUri && materialImage && (
                        <div style={{ paddingLeft: 15, marginBottom: 15 }}>
                            <Typography style={{ fontWeight: 500, color: '#33949E' }}>
                                Opgavemateriale
                            </Typography>
                            <a
                                target="_blank"
                                style={{ color: 'white', textDecoration: 'none', cursor: 'pointer' }}
                                href={materialUri}
                                rel="noreferrer">Se opgave-PDF
                            </a>
                        </div>

                    )}
                    <div style={{ paddingLeft: 15, marginBottom: 15 }}>
                        <Typography style={{ fontWeight: 500, color: '#33949E' }}>
                            Korrekte Svar
                        </Typography>
                    </div>
                    <div style={{ display: 'flex', justifyContent: 'center' }}>
                        <img style={{ width: '530px' }} src={answersImage} alt="Expected Answers"/>
                    </div>

                    <BouncyDiv style={{
                        backgroundImage: `linear-gradient(rgba(0,0,0,0.5),rgba(0,0,0,0.5)), url(${materialImage || map})`,
                        backgroundRepeat: 'no-repeat',
                        backgroundSize: 'cover',
                        minWidth: '30vw',
                        minHeight: '30vh',
                        height: 'auto',
                        borderRadius: 8
                    }}/>
                </DialogContent>
                <div style={{ display: 'flex', justifyContent: 'space-between', padding: '15px' }}>
                    {!!onSelect && !selected && (
                        <Button
                            onClick={() => onSelect(n * 60)}
                            disabled={!isGoodTime}
                            className={btnStyles.chooseTask}>Vælge Opgave
                        </Button>
                    )}
                    {!onSelect && (
                        <Button
                            onClick={() => {
                                onClose()
                                history.push(`/opgaver?selected=${title}`)
                            }}
                            className={btnStyles.chooseTask}>Gå til Opgaver
                        </Button>
                    )}
                </div>

            </Dialog>
        </div>
    )
}

PuzzleDetailsModal.defaultProps = {
    onSelect: undefined,
    selected: false,
    materialUri: '',
    materialKey: '',
    materialImage: ''
}
